module.exports = __webpack_public_path__ + "static/media/awale.ba1e236c.jpg";